// client/src/coms/views/chatview_parts/ChatViewScrollbarStyle.js
import React from 'react';

export default function ChatViewScrollbarStyle() {
  return (
    <style>{`
      .coms-messages--hide-scrollbar {
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      .coms-messages--hide-scrollbar::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    `}</style>
  );
}